import React from "react";
import { Wrench, Activity, ShieldCheck, Disc3, BatteryCharging, Cpu, Paintbrush, Sparkles, ClipboardCheck, Waves, RectangleHorizontal, Lightbulb, Truck, AlertTriangle, Hammer, Fan, Droplets, Package, type LucideIcon } from "lucide-react";
import { cn } from "../../lib/utils";

export const SERVICE_TYPE_ICONS: Record<string, LucideIcon> = { service: Wrench, servicing: Wrench, diagnose: Activity, warranty: ShieldCheck, tyres: Disc3, batteries: BatteryCharging, electronics: Cpu, body: Paintbrush, detailing: Sparkles, inspection: ClipboardCheck, suspension: Waves, windshield: RectangleHorizontal, lights: Lightbulb, towing: Truck, breakdown: AlertTriangle, repair: Hammer, ac: Fan, carwash: Droplets, parts: Package };

export function ServiceTypePicker({ options, value, onChange, testIdPrefix }: { options: { key: string; label: string }[]; value: string[]; onChange: (v: string[]) => void; testIdPrefix: string }) {
  const toggle = (k: string) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-testid={`${testIdPrefix}-picker`}>
      {options.map((o) => {
        const Icon = SERVICE_TYPE_ICONS[o.key] || Wrench;
        const on = value.includes(o.key);
        return (
          <button key={o.key} type="button" onClick={() => toggle(o.key)} aria-pressed={on} data-testid={`${testIdPrefix}-${o.key}`}
            className={cn("flex flex-col items-center gap-1.5 rounded-lg border px-2 py-3 text-xs font-semibold transition-all", on ? "border-[color:var(--brand)] bg-[color:var(--brand)] text-[color:var(--brand-fg)] shadow-sm" : "border-slate-200 bg-white text-slate-700 hover:border-slate-400")}>
            <Icon className={cn("h-4 w-4", on ? "" : "text-slate-500")} />{o.label}
          </button>
        );
      })}
    </div>
  );
}

export function ServiceTypeChips({ types, labels, testId }: { types: string[]; labels?: string; testId?: string }) {
  const names = (labels || "").split(", ");
  return (
    <span className="flex flex-wrap gap-1" data-testid={testId}>
      {types.filter(Boolean).map((t, i) => { const Icon = SERVICE_TYPE_ICONS[t] || Wrench; return <span key={t} className="inline-flex items-center gap-1 rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold text-slate-700"><Icon className="h-3 w-3 text-slate-500" />{names[i] || t}</span>; })}
    </span>
  );
}
